import moment from "moment";
import { useAppSelector } from "../../../../hooks/reduxDispatch";

const ChatBotInfo = () => {
  const { chatMessage, singleBotdata } = useAppSelector((s) => s.userBot);

  return (
    <div className=" bg-white border border-gray-200 rounded-lg shadow-inner p-6">
      <h1 className="text-xl font-semibold mb-4">{singleBotdata?.botName}</h1>
      <div className="space-y-2">
        <div>
          <p className="text-gray-600">Chatbot ID</p>
          <p className="text-gray-800">{singleBotdata?.botId}</p>
        </div>
        <div>
          <p className="text-gray-600">Status</p>
          <p className="text-green-500">Trained</p>
        </div>
        <div>
          <p className="text-gray-600">Model</p>
          <p className="text-gray-800">{singleBotdata?.model}</p>
        </div>
        <div>
          <p className="text-gray-600">Number of characters</p>
          <p className="text-gray-800">782</p>
        </div>
        {/* ... other details ... */}
        <div>
          <p className="text-gray-600">Last trained at</p>
          <p className="text-gray-800">
            {moment(singleBotdata?.lastTrained).format("LLLL")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ChatBotInfo;
